import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { TooltipProvider } from '@/components/ui/tooltip';

/** 应用外壳：全局 Provider 都挂在这里 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 账号数据变化不频繁，切回标签页不必每次重拉
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const AppContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider delayDuration={200}>{children}</TooltipProvider>
  </QueryClientProvider>
);

export default AppContainer;
